<template>
  <div>
    <div class="index-main-item5 textC flex_col_around">
      <div>
        <div class="title">开启雇前人力资源服务新时代</div>
        <div class="desc">和100,000+HR一起实现低成本、高效率、安全、精准雇佣</div>
      </div>
      <div class="btn" style="margin-bottom: 30px">
        <button class="btn1 fontSize_16" @click="$parent.dialogTableVisible1 = !$parent.dialogTableVisible1">立即免费试用</button>
        <!--<button class="btn2 fontSize_16" @click="toLogin">了解更多</button>-->
      </div>
    </div>
    <div class="index-main-item6 flex_col_between">
      <div class="flex_colC" style="height: 150px">
        <div style="width: 230px;height: 39px;margin: 0 auto">
          <img src="@/assets/new_index_logo1.png" class="W_100" alt="">
        </div>
        <div class="" style="padding-top: 10px">企业雇佣安全风险控制专家</div>
      </div>
      <div class="flex_rowC W_100">
        <div class="content">
          <div style="margin-right: 50px">
            <ul>
              <li class="cursorPointer">首页</li>
              <li class="cursorPointer">核心优势</li>
              <li class="cursorPointer">我们的产品</li>
              <li class="cursorPointer">企业说</li>
              <li class="cursorPointer">合作企业</li>
            </ul>
          </div>
          <div style="margin-right: 50px">
            <ul>
              <li class="cursorPointer">产品与服务</li>
              <li class="cursorPointer">简历公海</li>
              <li class="cursorPointer">背景调查</li>
              <li class="cursorPointer">招聘保险</li>
              <li class="cursorPointer">职业档案</li>
            </ul>
          </div>
          <div style="margin-right: 50px">
            <ul>
              <li class="cursorPointer">关于我们</li>
              <li class="cursorPointer">公司简介</li>
              <li class="cursorPointer">事业合伙人</li>
              <li class="cursorPointer">联系我们</li>
            </ul>
          </div>
          <div style="margin-right: 50px">
            <div class="flex_rowL">
              <img src="@/assets/new_index_icon9.png" alt="">
              <div style="font-size: 1rem;margin-left: 15px">电话：17701626688（朱经理）</div>
            </div>
            <div class="flex_rowL" style="margin: 20px 0">
              <img src="@/assets/new_index_icon9.png" alt="">
              <div style="font-size: 1rem;margin-left: 15px">电话：13916607979（徐经理）</div>
            </div>
            <div class="flex_rowL">
              <img src="@/assets/new_index_icon11.png" alt="">
              <div style="font-size: 1rem;margin-left: 13px">地址：上海市闵行区新龙路399弄56号T1栋</div>
            </div>
          </div>
          <div class="flex_rowR">
            <div class="flex_colT H_100" style="margin-right: 30px">
              <img src="@/assets/index_newsideNav_code3.5849324.png" alt="">
              
              <div style="margin-top: 20px">微信公众号</div>
            </div>
            <div class="flex_colT H_100">
              <img src="@/assets/luobo_shunshun.5899a16.png" style="width:118px;height:118px" alt="">
              <div style="margin-top: 20px">7+24小时客服</div>
            </div>
          </div>
        </div>
      </div>
      <div style="margin-bottom: 30px">©Copyright：上海城亿智能科技有限公司 沪ICP备16033631号-1</div>
    </div>
  </div>
</template>

<script>
  import '@/common/css/index.css'

  export default {
    name: "footer"
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/footerNav.vue